import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LighthouseIcon from "../../../assets/lighthouse.svg?react";
import { RightPanelTabs } from "../../../constants/Panels";
import { AppContext, LighthouseContext, UserContext } from "../../../Context";
import { setLoading, setRightPanelActiveTab } from "../../../store/appSlice";
import {
    setCurrentLighthouseTrueNorth,
    setIsSavingLighthouse,
    setSectorSourceStep,
} from "../../../store/lighthouseSlice";
import { StoreState } from "../../../store/rootReducer";
import { Sector } from "../../../utils/lighthouseConstants";
import { createPendingLighthouse } from "../../../utils/pendingLighthouse";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import "./SectorSourceDialog.css";

const SectorSourceDialog = () => {
    const dispatch = useDispatch();
    const appContext = useContext(AppContext);
    const lighthouseContext = useContext(LighthouseContext);
    const userContext = useContext(UserContext);

    const sectorSourceStep = useSelector((state: StoreState) => state.lighthouse.sectorSourceStep);
    const placement = appContext?.pendingLighthousePlacement.value.current;

    const [isCreating, setIsCreating] = useState(false);

    if (sectorSourceStep !== "choosing" || !placement) return null;

    const cancel = () => {
        appContext!.pendingLighthousePlacement.value.current = null;
        appContext!.createObjectCurrentEntryRef.value.current = null;
        dispatch(setSectorSourceStep("none"));
    };

    const create = async (sectors?: Sector[]) => {
        const entryTitle = appContext?.createObjectCurrentEntryRef.value.current;
        setIsCreating(true);

        try {
            await createPendingLighthouse({
                placement,
                sectors,
                userName: userContext?.user.value?.fullName,
                entryTitle,
                setSelectedFeature: appContext?.selectedFeature.set,
                setLighthouseData: (lighthouseData) => lighthouseContext?.lighthouseData.set(lighthouseData),
                setTrueNorth: (trueNorth) => dispatch(setCurrentLighthouseTrueNorth(trueNorth)),
                setIsSavingLighthouse: (isSaving) => dispatch(setIsSavingLighthouse(isSaving)),
                setLoading: (loadingStatus) => dispatch(setLoading(loadingStatus)),
            });
        } catch (error) {
            console.error("Kunne ikke opprette fyrlykten", error);
            toast.error("Kunne ikke opprette fyrlykten. Prøv igjen.");
            // The create turns the loader on and only turns it off when it runs to the end,
            // so a failure has to clear it or the overlay hides the dialog it asks to retry
            dispatch(setLoading(false));
            dispatch(setIsSavingLighthouse(false));
            setIsCreating(false);
            return;
        }

        appContext!.pendingLighthousePlacement.value.current = null;
        appContext!.createObjectCurrentEntryRef.value.current = null;
        setIsCreating(false);
        dispatch(setSectorSourceStep("none"));
        dispatch(setRightPanelActiveTab(RightPanelTabs.EDITOR));
    };

    return (
        <div className="sector-source-dialog-backdrop">
            <div className="sector-source-dialog">
                <div className="sector-source-dialog-header">
                    <LighthouseIcon />
                    <span>Sektorer</span>
                </div>
                <p>Hvordan vil du definere sektorene?</p>
                <div className="sector-source-dialog-actions">
                    <NfsButton onClick={() => create()} disabled={isCreating}>
                        Standardsektorer
                    </NfsButton>
                    <NfsButton onClick={() => dispatch(setSectorSourceStep("table"))} disabled={isCreating}>
                        Definer i tabell
                    </NfsButton>
                </div>
                <NfsButton onClick={cancel} empty outlined disabled={isCreating}>
                    Avbryt
                </NfsButton>
            </div>
        </div>
    );
};

export default SectorSourceDialog;
